import { Question, Reply, Value } from "containers/Survey/types"
import styles from "./Question.module.scss"
import DOMPurify from "dompurify"

export const UiQuestionsLine = (props: {
  onSelect: (reply: Reply) => void
  unSelect: (reply: Reply) => void
  answers: Value[]
  question: Question & { questions: Question[] }
}) => {
  const { question } = props

  const handleSelect = (questionId: string, reply: Reply) => {
    props.onSelect({ title: questionId, value: reply.value })
  }

  return (
    <div className={styles.QuestionsLine}>
      {question.questions.map((q) => (
        <div key={q.id} className={styles.QuestionLineItem}>
          {q.imgUrl && <img src={q.imgUrl} alt={q.title} height={80} />}
          <div className={styles.QuestionLineItemTitle}>
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(q.title, {
                  USE_PROFILES: { html: true },
                }),
              }}
            />
            {q.subtitle && (
              <span className={styles.QuestionLineItemSubtitle}>
                {q.subtitle}
              </span>
            )}
          </div>
          <div className={styles.QuestionLineItemReplies}>
            {q.replies.map((reply, index) => (
              <button
                key={index}
                onClick={() => handleSelect(q.id, reply)}
                className={
                  (props.answers as { title: string; value: Value }[]).find(
                    (a) => a.title === q.id,
                  )?.value === reply.value
                    ? styles.selected
                    : ""
                }
              >
                {reply.title}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
